import { render, staticRenderFns } from "./tag-item.vue?vue&type=template&id=589a0279&scoped=true"
import script from "./tag-item.vue?vue&type=script&lang=js"
export * from "./tag-item.vue?vue&type=script&lang=js"
import style0 from "./tag-item.vue?vue&type=style&index=0&id=589a0279&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589a0279",
  null
  
)

export default component.exports